/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '~core/services/constants.service';

export function applicationIdInterceptor(
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> {
  const constantsService = inject(ConstantsService);
  return next(
    request.clone({
      setHeaders: {
        'X-Application-Id': `${constantsService.environment.xApplicationId}`,
        'Accept-Language': 'fr-FR,fr;q=0.9'
      }
    })
  );
}
